import { render, staticRenderFns } from "./CardMinimal.vue?vue&type=template&id=540ced18&"
import script from "./CardMinimal.vue?vue&type=script&lang=js&"
export * from "./CardMinimal.vue?vue&type=script&lang=js&"
import style0 from "./CardMinimal.vue?vue&type=style&index=0&id=540ced18&prod&lang=scss&"
import style1 from "./CardMinimal.vue?vue&type=style&index=1&id=540ced18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports